import React from "react";
import { Col, Row } from "reactstrap";
import PropTypes from "prop-types";
import { get } from "lodash";

import Modal from "Components/Common/Modal";
import Collapse from "Components/Common/ViewApplicationDetailComponents/Collapse";
import Backdrop from "Components/Common/Backdrop";

import { useGetMeterReadingDetailsQuery } from "apis/MeterReading";

const fields = [
  {
    name: "Actual Max Demand",
    key: "actualMaxDemand",
    isRequired: false,
  },
  {
    name: "Pro Rata Consumption",
    key: "proRataConsumption",
    isRequired: false,
  },
  {
    name: "Reading",
    key: "reading",
    isRequired: false,
  },
  {
    name: "Return Water Temperature Penalty Charges",
    key: "returnWaterTemperaturePenaltyCharges",
    isRequired: false,
  },
  {
    name: "Note",
    key: "note",
    isRequired: false,
  },
  {
    name: "Demand Charge",
    key: "isDemandCharge",
    renderField: (value) => (value ? "Yes" : "No"),
  },
];

const MeterReadingDetailsModal = ({ applicationId, handleClose }) => {
  const { data: { data: meterReadingsData } = {}, isLoading } =
    useGetMeterReadingDetailsQuery(applicationId);

  if (isLoading) {
    <Backdrop open />;
  }

  return (
    <Modal
      isOpen
      handleClose={handleClose}
      title="Meter Readings"
      maxWidth="lg"
    >
      {meterReadingsData?.length ? (
        meterReadingsData.map((data, index) => (
          <Collapse
            title={data.isInitialReading ? "Initial Reading" : "Final Reading"}
            key={index}
          >
            <Row className="d-flex mb-2">
              {fields.map(
                ({ isVisible, name, key, isRequired, renderField }) => {
                  const value = get(data, key, "");
                  if (typeof isVisible !== "boolean" || isVisible) {
                    return (
                      <Col key={key} lg={6} className="mb-1">
                        <Row>
                          <Col md={7}>{name}:</Col>
                          <Col
                            md={5}
                            className="fw-semibold"
                            style={{ wordBreak: "break-word" }}
                          >
                            {renderField
                              ? renderField(value)
                              : get(data, key, null) ??
                                (isRequired ? "-" : "N/A")}
                          </Col>
                        </Row>
                      </Col>
                    );
                  }
                }
              )}
            </Row>
          </Collapse>
        ))
      ) : (
        <div className="d-flex justify-content-center align-items-center mt-3">
          No Data
        </div>
      )}
    </Modal>
  );
};

MeterReadingDetailsModal.propTypes = {
  applicationId: PropTypes.number,
  handleClose: PropTypes.func,
};

export default MeterReadingDetailsModal;
